
	import { Observer } from 'mobx-vue';
	import { Component, Vue } from 'vue-property-decorator';
	import UtilsStore from '@/store/utilsStore';
	import { SHOE_SIZE_UNIT, SHOE_TYPES, GetShoeSizes } from '@/store/ShoeMeasurements';

	@Observer
	@Component({
		components: {},
		filters: {
			capitalize(str: string | number) {
				if (typeof str !== 'string') str = str.toString();
				return UtilsStore.capitalize(str);
			}
		}
	})
	export default class ShoeSizePicker extends Vue {
		public SHOE_TYPES = SHOE_TYPES;
		public SHOE_SIZE_UNIT = SHOE_SIZE_UNIT;
		public getShoeSizes = GetShoeSizes;
		public options = ['Both feet wear same size shoes', 'Different shoe sizes'];
		private activeTab = this.options[this.$state._patient.patientUIData.shoeSizes.differentSizes ? 1 : 0];

		private isActive(option: string) {
			return this.activeTab === option ? 'selectionButton selected' : 'selectionButton';
		}

		private setActiveTab(option: string) {
			this.$state._patient.patientUIData.shoeSizes.differentSizes = option !== this.options[0];
			this.activeTab = option;
		}
	}
